<template>
  <div>deliverable</div>
</template>

<script>
export default {
  name: 'ADFormDeliverablesTab',
};
</script>

<style scoped></style>